import { GrantStatus, VisitationAgendaCaseModel, VisitationDecision } from '../../api-service/clients';

export interface GrantAssessmentDraft {
  decision: VisitationDecision | undefined;
  comment: string;
}

export interface VisitationAssessmentDraft {
  grants: Record<string, GrantAssessmentDraft>;
  reasoning: string;
  error?: string;
}

function decisionFromStatus(status: GrantStatus): VisitationDecision | undefined {
  if (status === GrantStatus.Granted) return VisitationDecision.Granted;
  if (status === GrantStatus.Rejected) return VisitationDecision.Rejected;
  return undefined;
}

export function initialAssessmentDraft(agendaCase: VisitationAgendaCaseModel): VisitationAssessmentDraft {
  return {
    reasoning: '',
    grants: Object.fromEntries(agendaCase.grants.map(grant => [grant.grantId, { decision: decisionFromStatus(grant.status), comment: grant.visitationComment ?? '' }])),
  };
}

export function isContinuationCase(agendaCase: VisitationAgendaCaseModel): boolean {
  return !!agendaCase.rulingContinuationId;
}

export function processValidationError(agendaCase: VisitationAgendaCaseModel, draft: VisitationAssessmentDraft): string | undefined {
  if (!draft.reasoning.trim()) {
    return 'Skriv teamets samlede begrundelse.';
  }
  if (isContinuationCase(agendaCase)) {
    const decisions = new Set(Object.values(draft.grants).map(grant => grant.decision));
    return decisions.size === 1 && !decisions.has(undefined) ? undefined : 'Vælg samme beslutning for alle bevillinger (indsatsen fortsætter eller ophører).';
  }
  return agendaCase.grants.every(grant => draft.grants[grant.grantId]?.decision) ? undefined : 'Vælg Tilkendt eller Afvist for alle bevillinger.';
}
